export default "__VITE_ASSET__DaXhZoF0__"